import { Inline } from '@spark-web/inline';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { TextLinkButton } from '@spark-web/text-link';
import { FC } from 'react';

import { Promotion } from '~/gql/graphql';
import { useModal } from '~/hooks/useModal';

import PromoTag from '../promo-tag';

type VendorCardPromoInfoProps = {
  promo: Pick<Promotion, 'title' | 'code' | 'tag' | 'publicDescription'>;
};

const VendorCardPromoInfo: FC<VendorCardPromoInfoProps> = ({ promo }) => {
  const { open } = useModal('promotion-information');

  return (
    <Stack gap="large" align="left" padding="large" borderRadius="medium" css={{ backgroundColor: '#f4f4f4' }}>
      <PromoTag theme="pantheon">
        <Text size="xsmall">{promo?.tag}</Text>
      </PromoTag>
      <Inline gap="small" alignY="center">
        {promo.publicDescription ? <Text size="small">{promo.publicDescription}</Text> : null}
        <Text tone="info" size="small">
          <TextLinkButton onClick={open}>See details</TextLinkButton>
        </Text>
      </Inline>
    </Stack>
  );
};

export { VendorCardPromoInfo };
